import * as React from "react";
import { styled } from "@mui/material";
import { ChiefComplaintPanel } from "./editPatient/ChiefComplaintPanel";
import { usePatientCase } from "./usePatientCase";
import { MobileView } from "../../util/aKaunGeneralUtil";

//region [[ Styles ]]

const ChiefComplaintPageView = styled(ChiefComplaintPanel)(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    paddingTop: "7px",
    paddingRight: "3vh",
    paddingLeft: "3vh",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ChiefComplaintPageProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ChiefComplaintPage = ({ ...props }: ChiefComplaintPageProps) => {
  const {
    handleSetChiefComplaint,
    handleRemoveChiefComplaint,
    patientCase,
  } = usePatientCase();

  return (
    <ChiefComplaintPageView
      removeChiefComplaint={handleRemoveChiefComplaint}
      setChiefComplaint={handleSetChiefComplaint}
      chiefComplaint={patientCase.main?.[0]} //TODO change when we support multiple
      gender={patientCase.gender}
    />
  );
};
